// Generated by purs version 0.15.0
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var Value = function (x) {
    return x;
};
var udecodeValue = Unscramble.decodeForeign;
var showValue = {
    show: function (v) {
        if (Foreign.isUndefined(v)) {
            return Data_Show.show(Data_Show.showString)("undefined");
        };
        if (Foreign.isNull(v)) {
            return Data_Show.show(Data_Show.showString)("null");
        };
        if (Data_Boolean.otherwise) {
            return Data_Show.show(Data_Show.showString)(Foreign_Generic.encodeJSON(Foreign_Generic_Class.foreignEncode)(v));
        };
        throw new Error("Failed pattern match at Data.Value (line 21, column 1 - line 26, column 38): " + [ v.constructor.name ]);
    }
};
var newtypeValue = {
    Coercible0: function () {
        return undefined;
    }
};
var encodeValue = Foreign_Generic_Class.foreignEncode;
var eqValue = {
    eq: /* #__PURE__ */ Data_Function.on(/* #__PURE__ */ Data_Eq.eq(Data_Eq.eqString))(/* #__PURE__ */ Foreign_Generic.encodeJSON(encodeValue))
};
var decodeValue = Foreign_Generic_Class.foreignDecode;
export {
    Value,
    newtypeValue,
    showValue,
    eqValue,
    decodeValue,
    udecodeValue,
    encodeValue
};
//# sourceMappingURL=index.js.map
